import React from 'react';

const YoutubeFeeds = () => {
  return <div>Youtube Feeds</div>;
};

export default YoutubeFeeds;
